<template>
  <div class="MyInput">
    <input name="" :type="type" :value="value" v-on:input="$emit('input', $event.target.value)" :placeholder="error?error:placeholder" :class="{error: error}" :style="inputStyle" :autocomplete="disfill?'off':'on'" />
  </div>
</template>

<script>
 export default {
   name: 'MyInput',
   props: ['value', 'type', 'placeholder', 'inputStyle', 'error', 'disfill']
 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .MyInput > input{
   border: none;
   border-bottom: 1px solid #E2E8ED;
   font-size: 0.83vw;
   line-height: 1.35vw !important;
   width: 100%;
   height: 3.4vw;
   box-sizing: border-box;
   padding-left: 0.78vw;
 }

 .MyInput > input.error{
   border: 1px solid red;
   box-shadow: red 0 0 10px;
 }

 input.error::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
   color: red;
   opacity: 1; /* Firefox */
 }
 @media (min-width: 320px) and (max-width: 480px) {
   .MyInput > input{
   font-size: 14px;
   line-height: 30px !important;
   height: 34px;
   }
 }
</style>
